export const getDashboardStats = (state) => state.dashboardStats
export const getStatistics = (state) => state.statistics
export const getWidgets = (state) => state.widgets
export const getAddedWidgets = (state) => state.addedWidgets
export const getSaleStatistics = (state) => state.saleStatistics

